var _rect, _path, _path2, _path3, _line, _ellipse, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrinary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#eff6ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145 95 C118 95 100 125 100 152 C100 180 118 205 145 205 C158 205 168 196 168 178 C168 162 158 153 158 153 C158 153 168 143 168 125 C168 108 158 95 145 95Z",
    fill: "white",
    stroke: "#3b82f6",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255 95 C282 95 300 125 300 152 C300 180 282 205 255 205 C242 205 232 196 232 178 C232 162 242 153 242 153 C242 153 232 143 232 125 C232 108 242 95 255 95Z",
    fill: "white",
    stroke: "#3b82f6",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168 162 L200 180 L232 162",
    stroke: "#3b82f6",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.35
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 200,
    y2: 222,
    stroke: "#3b82f6",
    strokeWidth: 2,
    opacity: 0.35
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 228,
    rx: 20,
    ry: 14,
    fill: "white",
    stroke: "#3b82f6",
    strokeWidth: 2,
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 274,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#1e40af"
  }, "Idrar Yolu")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrinary);
export default __webpack_public_path__ + "static/media/urinary.54c551e2f0ed5d27bf905c8106d9d76a.svg";
export { ForwardRef as ReactComponent };